/* cx: Kave-style variant sheet.
   Delegated listeners so handlers survive Dawn's variant-selects re-renders.
   Cards click the hidden native radio — Dawn handles price/media/availability.
   The sheet is re-parented to <body> on open: ancestor transforms (Dawn's
   scroll-reveal animations) otherwise break position:fixed. */
(function () {
  function closeSheet(sheet) {
    if (!sheet) return;
    sheet.hidden = true;
    document.documentElement.classList.remove('cx-vi-lock');
    var field = sheet.__cxField;
    var opener = field && field.querySelector('[data-cx-vi-open]');
    if (opener) opener.setAttribute('aria-expanded', 'false');
  }

  function fieldOf(sheetChild) {
    var sheet = sheetChild.closest('[data-cx-vi-sheet]');
    if (sheet && sheet.__cxField) return sheet.__cxField;
    return sheetChild.closest('[data-cx-vi]');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cx-vi-open]');
    if (opener) {
      var field = opener.closest('[data-cx-vi]');
      var sheet = field && (field.__cxSheet || field.querySelector('[data-cx-vi-sheet]'));
      if (sheet) {
        /* drop stale body-level sheets left behind by picker re-renders */
        document.querySelectorAll('body > [data-cx-vi-sheet]').forEach(function (s) {
          if (s !== sheet) s.remove();
        });
        sheet.__cxField = field;
        field.__cxSheet = sheet;
        if (sheet.parentElement !== document.body) document.body.appendChild(sheet);
        sheet.hidden = false;
        sheet.scrollTop = 0;
        /* measure the scrollbar BEFORE locking, pad the body by that much —
           otherwise the page shifts sideways on desktop when the bar vanishes */
        var sbw = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--cx-sbw', sbw + 'px');
        document.documentElement.classList.add('cx-vi-lock');
        opener.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var closer = e.target.closest('[data-cx-vi-close]');
    if (closer) {
      closeSheet(closer.closest('[data-cx-vi-sheet]'));
      return;
    }

    var card = e.target.closest('[data-cx-vi-select]');
    if (card) {
      var field2 = fieldOf(card);
      if (!field2) return;
      var value = card.getAttribute('data-cx-value');
      var fieldset = field2.previousElementSibling;
      if (fieldset && fieldset.classList.contains('cx-vi-hidden')) {
        var inputs = fieldset.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].value === value) {
            if (!inputs[i].checked) inputs[i].click();
            break;
          }
        }
      }
      /* optimistic UI update — a server re-render of the picker will confirm it */
      var sheet2 = card.closest('[data-cx-vi-sheet]');
      if (sheet2) {
        sheet2.querySelectorAll('[data-cx-vi-select]').forEach(function (c) {
          c.classList.toggle('is-selected', c === card);
        });
      }
      var valEl = field2.querySelector('[data-cx-vi-value]');
      if (valEl) valEl.textContent = value;
      var cardImg = card.querySelector('img');
      var thumb = field2.querySelector('[data-cx-vi-thumb]');
      if (cardImg && thumb) thumb.src = cardImg.src;
      closeSheet(sheet2);
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-cx-vi-sheet]:not([hidden])').forEach(closeSheet);
    }
  });
})();
